import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconGreaterThanOrEqual(props: IconSmallProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7601 6.32733C12.3886 6.73599 12.4187 7.36844 12.8273 7.73995L17.5134 12L12.8273 16.2601C12.4187 16.6316 12.3886 17.264 12.7601 17.6727C13.1316 18.0813 13.764 18.1115 14.1727 17.7399L19.6727 12.7399C19.8811 12.5504 20 12.2818 20 12C20 11.7183 19.8811 11.4496 19.6727 11.2601L14.1727 6.26007C13.764 5.88856 13.1316 5.91868 12.7601 6.32733Z"
        fill="currentColor"
      />
      <path
        d="M9.5 9C10.0523 9 10.5 9.44772 10.5 10C10.5 10.5523 10.0523 11 9.5 11H4.5C3.94771 11 3.5 10.5523 3.5 10C3.5 9.44772 3.94771 9 4.5 9H9.5Z"
        fill="currentColor"
      />
      <path
        d="M9.5 13C10.0523 13 10.5 13.4477 10.5 14C10.5 14.5523 10.0523 15 9.5 15H4.5C3.94771 15 3.5 14.5523 3.5 14C3.5 13.4477 3.94771 13 4.5 13H9.5Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
